import * as msal from '@azure/msal-browser'
import msalConfig from './msalConfig'
import OAuthAgent from './OAuthAgent'

// default export is a singleton
const OAuth = new OAuthAgent(new msal.PublicClientApplication(msalConfig))
export default OAuth